import { render } from "./main-area-workflow.vue?vue&type=template&id=9e9e36a8&scoped=true"
import script from "./main-area-workflow.vue?vue&type=script&lang=js"
export * from "./main-area-workflow.vue?vue&type=script&lang=js"

import "./main-area-workflow.vue?vue&type=style&index=0&id=9e9e36a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e9e36a8"]])

export default __exports__